import RouterLink from "./RouterLink";

export type { IRouterLinkProps } from "./RouterLink";

export default RouterLink;
